export const VERSION = '4.3.6-gogreen';
export const GIT_HASH = '1ec099551707e8f46c07a8ead1b5172df6e871a4';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
